import type { RouteObject } from "react-router-dom";
import Layout from "../Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

import MembersPage from "../pages/members/page";
import MembershipPage from "../pages/membership/page";
import AboutPage from "../pages/About/AboutPage";
import AmbassadorMessage from "@/pages/Ambasador/AmbassadorMessage";
import PresidentMessage from "@/pages/President/PresidentMessage";
import ServicesSection from "@/pages/About/ServicePage";
import NewsPage from "@/pages/home/components/NewsPage";
import EventPage from "@/pages/home/components/EventPage";
import PolicyPapersPage from "@/pages/Policy-Papers/Policypaperspage";
import HomeIt from "@/pages/HomeIt/HomePageIt";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/it",
        element: <HomeIt />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/services",
        element: <ServicesSection />,
      },
      {
        path: "/ambassador-message",
        element: <AmbassadorMessage />,
      },
      {
        path: "/president-message",
        element: <PresidentMessage />,
      },
      {
        path: "/members",
        element: <MembersPage />,
      },
      {
        path: "/membership",
        element: <MembershipPage />,
      },
      {
        path: "/news",
        element: <NewsPage />,
      },
      {
        path: "/news/policy-papers",
        element: <PolicyPapersPage />,
      },
      {
        path: "/events",
        element: <EventPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;